/** The storefront's error page (its own module: the page is in every route's browser bundle). */
export const shopError = {
    title: "কিছু একটা সমস্যা হয়েছে",
    body: "একটু পরে আবার চেষ্টা করুন।",
    retry: "আবার চেষ্টা করুন",
};
//# sourceMappingURL=shop-error.js.map